
const dimensionsMap = () => {
    const dim_map = {
        date: {label: 'Date', spark: () => 'date'},
        symbol: {label: 'Symbol', spark: () => 'symbol'},
    };
    return dim_map
};

export {dimensionsMap};